import React from 'react';

import { IIconProps } from 'assets/icons/IconProps';

export const RentisticLogo = ({ width = 43, height = 43 }: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 43 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="21.3975" cy="21" r="20" fill="white" stroke="#BC3D3B" strokeWidth="2" />
    <path
      d="M25.7554 28.5849L22.457 23.7376C22.3186 23.7534 22.111 23.7613 21.8342 23.7613H18.1899V28.5849H15.1914V12.0332H21.8342C23.2335 12.0332 24.4483 12.2697 25.4786 12.7426C26.5242 13.2155 27.3238 13.8933 27.8774 14.7761C28.4309 15.6588 28.7077 16.7071 28.7077 17.9209C28.7077 19.1662 28.4079 20.2381 27.8082 21.1367C27.2239 22.0352 26.3781 22.7051 25.271 23.1465L28.9845 28.5849H25.7554ZM25.6862 17.9209C25.6862 16.8647 25.3479 16.0529 24.6713 15.4854C23.9947 14.9179 23.0029 14.6342 21.6958 14.6342H18.1899V21.2312H21.6958C23.0029 21.2312 23.9947 20.9475 24.6713 20.38C25.3479 19.7968 25.6862 18.977 25.6862 17.9209Z"
      fill="#383643"
    />
  </svg>
);
